import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Close modal on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setActiveModal(null);
      }
    };
    if (activeModal) {
      window.addEventListener('keydown', handleKeyDown);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  const renderModalContent = () => {
    if (activeModal === 'privacy') {
      return <div className="space-y-6 text-charcoal/80" data-id="element-41">
          <h2 className="font-serif text-3xl text-charcoal mb-6" data-id="element-42">
            Política de Privacidad
          </h2>

          <section data-id="element-43">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-44">
              1. Recopilación de Información
            </h3>
            <p className="leading-relaxed" data-id="element-45">
              Recopilamos la información necesaria para procesar su compra y
              entregar el producto digital. Esto incluye su nombre, dirección de
              correo electrónico y detalles de la transacción. No almacenamos
              información de tarjetas de crédito, ya que los pagos son
              procesados de forma segura a través de pasarelas de pago de
              terceros.
            </p>
          </section>

          <section data-id="element-46">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-47">
              2. Uso de la Información
            </h3>
            <p className="leading-relaxed" data-id="element-48">
              La información recopilada se utiliza exclusivamente para:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-49">
              <li data-id="element-50">
                Procesar y entregar su pedido ("Legado en Vida: El Kit de No Me
                Olvides").
              </li>
              <li data-id="element-51">Enviar actualizaciones importantes sobre su compra.</li>
              <li data-id="element-52">Mejorar la experiencia del usuario en nuestro sitio web.</li>
            </ul>
          </section>

          <section data-id="element-53">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-54">
              3. Cookies y Tecnologías de Seguimiento
            </h3>
            <p className="leading-relaxed" data-id="element-55">
              Utilizamos cookies esenciales para el funcionamiento del carrito
              de compras y píxeles de seguimiento para analizar el rendimiento
              de nuestras campañas publicitarias y mejorar nuestros servicios.
              Puede configurar su navegador para rechazar las cookies, aunque
              esto podría afectar la funcionalidad del sitio.
            </p>
          </section>

          <section data-id="element-56">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-57">
              4. Compartir Información
            </h3>
            <p className="leading-relaxed" data-id="element-58">
              No vendemos, alquilamos ni compartimos su información personal con
              terceros para fines de marketing. Su información solo se comparte
              con proveedores de servicios esenciales (como procesadores de pago
              y plataformas de alojamiento) que nos ayudan a operar el negocio y
              entregar el producto.
            </p>
          </section>

          <section data-id="element-59">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-60">
              5. Sus Derechos
            </h3>
            <p className="leading-relaxed" data-id="element-61">
              Usted tiene derecho a solicitar el acceso, la corrección o la
              eliminación de sus datos personales almacenados en nuestros
              sistemas en cualquier momento.
            </p>
          </section>
        </div>;
    }
    if (activeModal === 'terms') {
      return <div className="space-y-6 text-charcoal/80" data-id="element-62">
          <h2 className="font-serif text-3xl text-charcoal mb-6" data-id="element-63">
            Términos y Condiciones
          </h2>

          <section data-id="element-64">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-65">
              1. Aceptación de los Términos
            </h3>
            <p className="leading-relaxed" data-id="element-66">
              Al acceder y realizar una compra en este sitio web, usted acepta
              estar sujeto a estos Términos y Condiciones. Si no está de acuerdo
              con alguna parte de estos términos, no debe realizar la compra ni
              utilizar nuestros productos.
            </p>
          </section>

          <section data-id="element-67">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-68">
              2. Propiedad Intelectual y Licencia
            </h3>
            <p className="leading-relaxed" data-id="element-69">
              El producto "Legado en Vida: El Kit de No Me Olvides" y todo su
              contenido están protegidos por derechos de autor. Al realizar la
              compra, se le otorga una licencia personal, no exclusiva e
              intransferible para usar el material. Queda estrictamente
              prohibida la reventa, distribución, modificación o uso comercial
              de este producto.
            </p>
          </section>

          <section data-id="element-70">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-71">
              3. Naturaleza del Producto
            </h3>
            <p className="leading-relaxed" data-id="element-72">
              Este producto es una herramienta organizativa y de planificación
              personal. No constituye asesoramiento legal, financiero ni médico.
              Para asuntos legales complejos, planificación patrimonial oficial
              o testamentos con validez legal, debe consultar con un abogado
              certificado en su jurisdicción.
            </p>
          </section>

          <section data-id="element-73">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-74">
              4. Política de Reembolsos
            </h3>
            <p className="leading-relaxed" data-id="element-75">
              Debido a la naturaleza digital y descargable del producto, todas
              las ventas son finales. Una vez que el archivo ha sido descargado
              o se ha otorgado el acceso, no se emitirán reembolsos.
            </p>
          </section>

          <section data-id="element-76">
            <h3 className="font-serif text-xl text-sage mb-2" data-id="element-77">
              5. Limitación de Responsabilidad
            </h3>
            <p className="leading-relaxed" data-id="element-78">
              En la máxima medida permitida por la ley, no seremos responsables
              por ningún daño directo, indirecto, incidental o consecuente que
              resulte del uso o la imposibilidad de usar nuestro producto. El
              usuario asume toda la responsabilidad por cómo decide utilizar la
              información proporcionada en el kit.
            </p>
          </section>
        </div>;
    }
    return null;
  };
  return <>
      <footer className="bg-charcoal text-cream/80 py-12 px-6 text-center relative z-10" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <p className="font-serif text-2xl text-cream mb-6 italic" data-id="element-81">
            Legado en Vida
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-82">
            <button onClick={() => setActiveModal('privacy')} className="text-cream/70 hover:text-cream hover:underline transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sage rounded" data-id="element-83">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-cream/70 hover:text-cream hover:underline transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sage rounded" data-id="element-84">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm mb-4" data-id="element-85">
            © {new Date().getFullYear()} Legado en Vida. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-cream/50 max-w-2xl mx-auto leading-relaxed" data-id="element-86">
            Este producto es una herramienta organizativa y no sustituye el
            consejo legal profesional. Para asuntos legales complejos, consulte
            siempre con un abogado especializado en su país.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-87">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-88">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} aria-hidden="true" data-id="element-89" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          type: 'spring',
          bounce: 0.2
        }} className="relative w-full max-w-2xl bg-cream rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" role="dialog" aria-modal="true" data-id="element-90">
              {/* Modal Header */}
              <div className="flex items-center justify-end p-4 border-b border-sage/10 bg-cream z-10" data-id="element-91">
                <button onClick={() => setActiveModal(null)} className="p-2 text-muted hover:text-charcoal hover:bg-sage/10 rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sage" aria-label="Cerrar modal" data-id="element-92">
                  <XIcon className="w-6 h-6" data-id="element-93" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 sm:p-8 overflow-y-auto overscroll-contain" data-id="element-94">
                {renderModalContent()}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}